import { useCallback, useState } from 'react';
import { Box, Button, IconSort, Input, Wrapper } from '@screentone/core';
import debounce from 'lodash.debounce';

import { NewslettersSearchInput } from 'data/generated/graphql';
import { DEBOUNCE_TIMEOUT } from '../../constants';
import styles from '../../NewsletterEdit.module.scss';

export const NewsletterSearchBar = ({
  newslettersInput,
  onPartialNewslettersInputChange
}: {
  newslettersInput: NewslettersSearchInput;
  onPartialNewslettersInputChange: (s: Partial<NewslettersSearchInput>) => void;
}) => {
  const [searchInput, setSearchInput] = useState(newslettersInput.searchText);

  const debouncedSearch = debounce((newSearchText: string) => {
    onPartialNewslettersInputChange({ searchText: newSearchText });
  }, DEBOUNCE_TIMEOUT);

  const handleSearchTextChange = useCallback(debouncedSearch, [debouncedSearch]);

  const handleSearchInputChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setSearchInput(e.target.value);
    handleSearchTextChange(e.target.value);
  };

  return (
    <Wrapper padding={{ top: 'sm', bottom: 'md' }}>
      <Box padding={{ all: 'sm' }} className={styles.searchBar} data-testid="newsletter-search-bar">
        <Input
          type="text"
          placeholder="Search by newsletter name"
          value={searchInput ?? ''}
          onChange={handleSearchInputChange}
          margin={{ right: 'sm' }}
        />
        <Button disabled tertiary icon={IconSort}>
          Sort: Create Date
        </Button>
      </Box>
    </Wrapper>
  );
};
